import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsUpLeft: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M15.84.16L.16 15.84V.16z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsUpLeft
